export const Constant = {
  DEFAULT_CATEGORY_COLOR: '#F2C511',
  DEFAULT_USER_TYPE: 'people',
  NAVI_USER_TYPE: 'navi',
  ENVIROMENT_USER_TYPE: 'enviroment',
  NAVI_FLOWS: {
    NO: 'no',
    LOW: 'low',
    NORMAL: 'normal',
    HIGHT: 'high',
  },
  MAP_MAX_INIT_ZOOM: 25,
  // Alert from jbox might not available soon.
  ALERT_CODE_BEACON_OUT: '1',
  ALERT_CODE_BEACON_BACK: '2',
  ALERT_CODE_BEACON_FAIL: '3',
  ALERT_CODE_BEACON_OK: '4',
  ALERT_CODE_LOC_FAIL: '1',
  ALERT_CODE_LOC_BACK: '2',
  BEACON_TYPE_ALL: 'all',
  BEACON_TYPE_STATIC: 'static',
  BEACON_TYPE_CARRIED: 'carried',
  CARD_TYPE_STATIC: 'static', // Jcard is a gateway
  CARD_TYPE_CARRIED: 'carried', // Normal Jcard
  CARD_TYPE_JCARD: 'jcard',
  CARD_TYPE_SMARTJCARD: 'smart_jcard',
  DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  DATE_FORMAT: 'YYYY/MM/DD',
  DATE_FORMAT_QUERY: 'YYYY-MM-DD',
  FETCH_TIME_MINUTES: 3, // use 0.1 to test
  PRE_FIX_BG_GEOFENCE: '-STA-',
}
